import { Text, View } from "react-native";
import { Link, Slot, Stack, useLocalSearchParams } from "expo-router";

import { PageMeta } from "~/components/PageMeta";
import { ResponsiveRenderer } from "~/components/ResponsiveRenderer";
import { useCurrentSpace } from "~/hooks/useCurrentSpace";

export const unstable_settings = {
  initialRouteName: "index",
};
export default function SpaceLayout() {
  const localParams = useLocalSearchParams<{
    account: string;
    space: string;
  }>();
  try {
    const { space } = useCurrentSpace();
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <PageMeta title={space.displayName ?? space.slug} />
        <ResponsiveRenderer
          webDesktop={<Slot />}
          default={
            <Stack screenOptions={{}}>
              <Stack.Screen
                name="imagePreview"
                options={{
                  animation: "default",
                  presentation: "modal",
                  title: "Image Preview",
                }}
              />
            </Stack>
          }
        />
      </>
    );
  } catch (e) {
    return (
      <>
        <Stack.Screen options={{ headerTitle: "" }} />
        <View className="items-center justify-center">
          <Text className="text-text-primary text-2xl">
            Workspace {localParams.space} not found or not accessible.
          </Text>
          <Link
            href={{
              pathname: "/(app)/(authenticated)/[account]/(account)",
              params: { account: localParams.account },
            }}
          >
            <Text className="text-text-primary">Return to account home</Text>
          </Link>
        </View>
      </>
    );
  }
}
